import { getParams } from '../atsReports/common/get-params';

type CustomReportData = {
  timeFrame: any;
  filters: any;
  filterParams: any;
  tableGroups: any;
};

export const getCustomReportData = (
  state,
  tableId = null,
  isCompare = false
): CustomReportData => {
  const { timeFrame, filters, tableGroups } = state.customReports;
  const filterParams = getParams({
    timeFrame,
    group: tableId ? tableGroups[tableId] : undefined,
    filters,
    compare: isCompare,
  });

  return {
    timeFrame,
    filters,
    filterParams,
    tableGroups,
  };
};

export const selectChartType = (state: any, chartKey: string) => {
  return state.customReports.chartTypes[chartKey];
};
